<template>
  <div class="refinement-category">
    <div class="title">{{ rangeFilter.label }}</div>
    <div class="range-selection">
      <input
        ref="minEl"
        placeholder="Min"
        type="number"
        min="0"
        :max="max"
        :name="rangeFilter.min.name"
        :value="rangeFilter.min.value"
        inputmode="numeric"
        pattern="[0-9]*"
        @input="updateRange"
      />
      <span>–</span>
      <input
        ref="maxEl"
        placeholder="Max"
        type="number"
        min="0"
        :max="max"
        :name="rangeFilter.max.name"
        :value="rangeFilter.max.value"
        inputmode="numeric"
        pattern="[0-9]*"
        @input="updateRange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Numeric range what to test:
 * [x] No errors on plans page that doesn't have any
 * [x] Can set min or max in UI and gets written to pinia
 * [x] The tag is correctly created for the range
 * [x] the url is correctly built for them
 * [x] On load from url args, correctly built to pinia and to ui
 * [x] Clearing specific tag clears pinia and UI
 * [x] Clear all from tags clears pinia and UI
 * [x] Clear all from mobile filters clears pinia and UI
 */

import { ref } from 'vue'
import _debounce from 'lodash/debounce'
import { useSearchStore } from '@/stores/search'
import type { RangeFilter } from '@/types/search-types'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    rangeFilter: RangeFilter
    max: string
  }>(),
  {},
)

/** STATE **/
const searchStore = useSearchStore()
const minEl = ref<HTMLInputElement | null>(null)
const maxEl = ref<HTMLInputElement | null>(null)

/** EMITS **/
const emit = defineEmits(['range-change'])

/** METHODS **/
const updateRange = _debounce(() => {
  if (!minEl.value || !maxEl.value) {
    return
  }

  // update store
  searchStore.setRangeMinMaxValue({
    filterName: props.rangeFilter.name,
    minValue: minEl.value.value,
    maxValue: maxEl.value.value,
  })

  const rangeTagItem = searchStore.rangeTagItem({
    filterName: props.rangeFilter.name,
    minValue: minEl.value.value,
    maxValue: maxEl.value.value,
    units: props.rangeFilter.units,
  })

  emit('range-change', rangeTagItem)
}, 500)
</script>
